import { useState } from "react";

import "./stylesUserDeletionModal.css";

import BlockUserIcon from "../../../../assets/icons/ic_block-user.svg";

import { CloseOutlined } from "@ant-design/icons";

import { Input, Select } from "antd";

function UserDeletionModal({ handleCancel }) {
  const [step, setStep] = useState(0);

  const [formData, setFormData] = useState({
    filterSegment: null,
    minTransactions: "",
  });

  const handleFieldChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
  };

  const onCancel = () => {
    setStep(0);
    handleCancel();
  };

  return (
    <div className="user-deletion-modal-container">
      <div className="modal-header">
        <div className="modal-header-title">
          <img src={BlockUserIcon} alt="Block User" />
          <h2 className="modal-title"> User Deletion</h2>
        </div>
        <CloseOutlined onClick={handleCancel} className="close-icon" />
      </div>

      <div className="modal-content">
        {step === 0 && (
          <>
            <p className="modal-content-title">
              Do you really want to delete this user?
            </p>
          </>
        )}
        {step === 1 && (
          <>
            <div className="divider" />

            <div className="transaction-info-item">
              <span>Reason</span>
              <Select
                value={formData.filterSegment}
                onChange={(value) => handleFieldChange("filterSegment", value)}
                options={[
                  { value: "Suspected activity", label: "Suspected activity" },
                  { value: "Spamming", label: "Spamming" },
                  { value: "Fraud", label: "Fraud" },
                  { value: "Other", label: "Other" },
                ]}
              />
            </div>
            <div className="transaction-info-item">
              <Input.TextArea
                type="text"
                value={formData.minTransactions}
                maxLength={255}
                rows={3}
                onChange={(e) =>
                  handleFieldChange("minTransactions", e.target.value)
                }
              />
              <span className="max-length">
                {formData.minTransactions.length}/255
              </span>
            </div>
          </>
        )}
      </div>

      <div className="divider" />
      <div className="modal-footer">
        {step === 0 && (
          <div className="buttons">
            <button className="cancel-button" onClick={onCancel}>
              No
            </button>
            <button
              className="save-button"
              onClick={() => {
                setStep(1);
              }}
            >
              Yes
            </button>
          </div>
        )}
        {step === 1 && (
          <div className="buttons">
            <button className="cancel-button" onClick={onCancel}>
              Close
            </button>
            <button
              className="save-button"
              onClick={() => {
                console.log("Form Data:", formData);
                // Aqui você pode enviar os dados para sua API
              }}
            >
              Save
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default UserDeletionModal;
